import { VStack } from "@chakra-ui/react";
import React from "react";
import { HiOutlinePlay, HiOutlineTrash } from "react-icons/hi2";

import { IconButton } from "../../../../components";
import { disabledButtonStyles, enabledButtonStyles } from "./styles";

type ActionButtonsProps = {
  playEnabled?: boolean;
  removeEnabled?: boolean;
  isRemoving?: boolean;
  onPlay?: () => void;
  onRemove?: () => void;
};

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  playEnabled = false,
  removeEnabled = true,
  isRemoving = false,
  onPlay,
  onRemove,
}) => (
  <VStack spacing="8px" align="center" justify="center" flexShrink={0}>
    <IconButton
      aria-label="Play"
      icon={<HiOutlinePlay size={16} />}
      {...(playEnabled ? enabledButtonStyles : disabledButtonStyles)}
      size="xs"
      borderRadius="4px"
      minW="24px"
      width="24px"
      height="24px"
      p="4px"
      isDisabled={!playEnabled}
      onClick={playEnabled ? onPlay : undefined}
    />
    <IconButton
      aria-label="Remove"
      icon={<HiOutlineTrash size={16} />}
      {...(removeEnabled && !isRemoving
        ? enabledButtonStyles
        : disabledButtonStyles)}
      size="xs"
      borderRadius="4px"
      minW="24px"
      width="24px"
      height="24px"
      p="4px"
      isDisabled={!removeEnabled || isRemoving}
      isLoading={isRemoving}
      onClick={removeEnabled && !isRemoving ? onRemove : undefined}
    />
  </VStack>
);
